import api from '@src/api/clients';

const BASE_URL = 'v1/keys/';

export const listApiKeys = (clientId) =>
  api.request({ url: BASE_URL, method: 'GET', payload: { client_id: clientId } });

export const createApiKey = (payload) =>
  api.request({ url: BASE_URL, method: 'POST', payload });

export const revokeApiKey = (keyId) =>
  api.request({ url: `${BASE_URL}${keyId}/`, method: 'DELETE' });

export default { listApiKeys, createApiKey, revokeApiKey };
